export default __webpack_public_path__ + "static/media/InvoiceActive.3d142eba.svg";